
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import HomePlan from "./HomePlan";

export default function UpdatePlane() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("Package Benefits")} parent={t("Home")} title={t("Package Benefits")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <HomePlan/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
